export default __webpack_public_path__ + "static/media/male_alt.a834c361.png";